import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Overlay, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getCustomHerbByFormulaId,
  getFavoriteFormula,
  getHerbByFormulaId,
} from "../../actions/formulaAction";
import { ERROR } from "../../constants/types/alertType";
const FavoriteFormulaList = ({
  isRawType,
  closePopup,
  includeDosage,
  setIncludeDosage,
}) => {
  const formulaList = useSelector(
    (state) => state.formula.present.favoriteFormulaList
  );
  const target = useRef(null);
  const formulas = useSelector((state) => state.formula.present.formulaSection);
  const [filteredList, setFilteredList] = useState([]);
  const [dosage, setDosage] = useState();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getFavoriteFormula());
  }, [dispatch]);

  useEffect(() => {
    setFilteredList(formulaList);
  }, [formulaList]);

  const handleChange = (e) => {
    let searchTerm = e.target.value;
    let newList = formulaList.filter((x) =>
      x.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredList(newList);
  };

  const modifyAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <div className="action-btn-wrapper row">
        <button
          className="btn-orange btn-table "
          disabled={
            formatExtraData.includeDosage &&
            (formatExtraData.dosage <= 0 || isNaN(formatExtraData.dosage)) &&
            !isRawType
          }
          onClick={() => {
            if (formulas.some((x) => x.formulaId === row.id)) {
              dispatch({
                type: ERROR,
                payload: "Selected Formula is already in the list",
              });
            } else {
              if (row.custom) {
                dispatch(
                  getCustomHerbByFormulaId(
                    row.id,
                    row.name,
                    null,
                    includeDosage ? dosage : 0.001,
                    true
                  )
                );
              } else {
                dispatch(
                  getHerbByFormulaId(
                    row.id,
                    row.name,
                    null,
                    includeDosage ? dosage : 0.001
                  )
                );
              }
            }

            closePopup();
          }}
        >
          Load
        </button>
      </div>
    );
  };

  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },

    {
      text: "Action",
      formatter: modifyAction,
      formatExtraData: { dosage: dosage, includeDosage: includeDosage },
    },
  ];

  return (
    <div>
      <p className="page-desc">Select or search Favorite Formulas by name.</p>
      {formulaList.length > 0 ? (
        <>
          {!isRawType && (
            <div className="row align-items-center mb-4 justify-content-between">
              {/* <div className="col-md-5">
                <div className="radio-item">
                  <label
                    className="container"
                    onClick={() => setIncludeDosage(true)}
                  >
                    Include Suggested Dosages
                    <input
                      type="radio"
                      checked={includeDosage}
                      name="existing"
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="radio-item">
                  <label
                    className="container"
                    onClick={() => setIncludeDosage(false)}
                  >
                    Do Not Include Suggested Dosages
                    <input type="radio" name="new" checked={!includeDosage} />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div> */}
              {includeDosage && (
                <>
                  <div className="col-md-4 text-right">
                    Total amount (grams) of this formula:
                  </div>

                  <div className=" d-flex justify-content-end">
                    <input
                      ref={target}
                      disabled={!includeDosage}
                      type="number"
                      step=".5"
                      min={0}
                      style={{ width: "auto", marginRight: "20px" }}
                      placeholder="enter your dosage"
                      className={`gram-input formula ${
                        dosage == null || isNaN(dosage) ? "red-border" : ""
                      }`}
                      value={dosage}
                      onChange={(e) => {
                        e.target.value >= 0
                          ? setDosage(parseFloat(e.target.value))
                          : setDosage(null);
                      }}
                    />
                    <Overlay
                      target={target.current}
                      show={dosage == null || isNaN(dosage) || dosage <= 0}
                      placement="top"
                    >
                      {(props) => (
                        <Tooltip id="overlay-example" {...props}>
                          You must enter a dosage
                        </Tooltip>
                      )}
                    </Overlay>
                  </div>
                </>
              )}
            </div>
          )}
          <div className="row mt-1">
            <div className="col-md-8">
              <div className="form-group search">
                <div>
                  <label htmlFor="search">Favorite Formula Name:</label>
                  <div className="input">
                    <input
                      name="search"
                      className="form-control"
                      id="search"
                      onChange={handleChange}
                      type="text"
                    ></input>
                  </div>
                </div>
                <FontAwesomeIcon icon={faSearch} size="lg" color="gray" />
              </div>
            </div>
          </div>
          <BootstrapTable
            classes="react-bootstrap-table"
            keyField="id"
            maxHeight="300px"
            columns={columns}
            data={filteredList}
            headerClasses="header-class"
          />
        </>
      ) : (
        <p className="page-desc">There are no formula at this time</p>
      )}
    </div>
  );
};
export default FavoriteFormulaList;
